module.exports = __webpack_public_path__ + "img/loading_b.a74867ad.gif";